import React, {Component} from "react";

export default class Home extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <div className="ui inverted vertical masthead center aligned segment">
                    <div className="ui text container">
                        <h1 className="ui inverted header">
                            Echo Bank Agent
                        </h1>
                        <h2>The power of banking, brought to your voice.</h2>
                        <a href={"/accounts"}>
                            <div className="ui huge primary button">Begin Exploring <i className="right arrow icon"></i></div>
                        </a>
                    </div>

                </div>

                <div className="ui vertical stripe segment">
                    <div className="ui middle aligned stackable grid container">
                        <div className="row">
                            <div className="eight wide column">
                                <h3 className="ui header">Use Alexa for voice banking</h3>
                                <p>Alexa is a spectacularly powerful device, capable of far-more than reading your local
                                    weather. Our platform utilizes alexa's superior
                                    artificial intelligence to deliver a one-of-a-class banking experience.</p>

                                <h3 className="ui header">Stay on top of your accounts</h3>
                                <p>We realize that you may have multiple credit, debit and/or savings accounts across
                                    multiple institutions.
                                    We also realize that it is not fun to navigate through 7 different apps to find
                                    everything you need. With us, you can use your voice to
                                    access all your financial data in the most seamless way.</p>

                                <h3 className="ui header"> Data Security </h3>
                                <p>Data security is of paramount importance to us. We utilize the same platform used by
                                    popular apps such as Venmo, Zelle, and Robinhood to access your financial
                                    institutions. On our side, we use an end-to-end encryption scheme to store,
                                    transmit, and manage all of our users' data.
                                </p>

                                <h3 className="ui header"> Your Data Privacy </h3>
                                <p>We pledge to keep all your data private, which means to never share your financial
                                    data with any external business or organization. Your data is yours, and will
                                    forever stay as such under our stewardship.
                                </p>

                            </div>
                            <div className="six wide right floated column">
                                <img src="/img/alexa.jpg" className="ui large bordered rounded image"></img>
                            </div>
                        </div>
                        <div className="row">
                            <div className="center aligned column">
                                <a className="ui huge button loginModalButton">Login To Start</a>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}